'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = Chat;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _renderIf = require('render-if');

var _renderIf2 = _interopRequireDefault(_renderIf);

var _discussions = require('../api/discussions');

var _DiscussionCardListContainer = require('./DiscussionCardListContainer');

var _DiscussionCardListContainer2 = _interopRequireDefault(_DiscussionCardListContainer);

var _DiscussionContainer = require('./DiscussionContainer');

var _DiscussionContainer2 = _interopRequireDefault(_DiscussionContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *
 */
function Chat(_ref) {
	var id = _ref.id;
	var activeDiscussionId = _ref.activeDiscussionId;

	return _react2.default.createElement(
		'section',
		{ className: 'vtChat-Chat' },
		_react2.default.createElement(
			'header',
			{ className: 'vtChat-Chat-header' },
			_react2.default.createElement(
				'h2',
				{ className: 'vtChat-Chat-title' },
				_react2.default.createElement(_reactIntl.FormattedMessage, { id: 'vtChat.Chat.title' })
			)
		),
		_react2.default.createElement(
			'div',
			{ className: 'vtChat-Chat-body' },
			_react2.default.createElement(
				'div',
				{ className: 'vtChat-Chat-discussionCards' },
				[_discussions.Status.OPEN, _discussions.Status.PENDING].map(function (status) {
					return _react2.default.createElement(_DiscussionCardListContainer2.default, {
						key: status,
						chatId: id,
						status: status,
						title: _react2.default.createElement(_reactIntl.FormattedMessage, {
							id: 'vtChat.Chat.discussions',
							values: { status: status }
						})
					});
				})
			),
			_react2.default.createElement(
				'div',
				{ className: 'vtChat-Chat-discussion' },
				(0, _renderIf2.default)(activeDiscussionId)(function () {
					return _react2.default.createElement(_DiscussionContainer2.default, { chatId: id, id: activeDiscussionId });
				})
			)
		)
	);
}

Chat.propTypes = {
	id: _react.PropTypes.string.isRequired,
	activeDiscussionId: _react.PropTypes.string
};